import { AxiosResponse } from 'axios';
import { ProductSection } from 'types/Sections';
import fetchAPI from 'utils/functions/fetchAPI';
import { baseUrl } from '../const';

interface GetProduct {
  /** CommandId của section product cần lấy dữ liệu */
  commandId: string;
}
interface ResponseSuccess extends ProductSection {}

/**
 * It takes a commandId and returns the newest version of the product
 * @param {GetProduct}  - GetProduct
 * @returns ProductSection
 */
export const updateVersion = async ({ commandId }: GetProduct) => {
  const response: AxiosResponse<ResponseSuccess> = await fetchAPI.request({
    url: `${baseUrl}/${commandId}/newest`,
  });

  return response.data as ProductSection;
};
